<template>
  <div ref="wallet" class="wallet flex-between">
    <div class="wallet-card wallet-cash flex-between">
      <div class="wallet-action cash-refresh" @click="refreshAllSlot">
        <i class="fas fa-sync-alt"></i>
      </div>
      <div class="wallet-info">
        <div class="wallet-label">
          {{ $t('home.checkBalance') }} ({{ $t('modals.transfer.bahtTxt') }})
        </div>
        <div class="flex">
          <span class="wallet-amount">
            {{ $options.filters.numberFormat(total) }}
          </span>
          <button
            v-if="isSpinActive"
            class="button small is-primary"
            @click="modalSpin(false)"
          >
            <div class="coin">
              <i class="fas fa-coins"></i>{{ this.profile.coin }}
            </div>
          </button>
        </div>
        <div class="wallet-update">
          {{ $t('home.updateTime') }} {{ timesync | datetimeFormat }}
        </div>
      </div>
    </div>
    <div
      v-if="isMobile"
      class="wallet-action wallet-switch"
      @click="switchWallet"
    >
      <i
        class="fas fa-chevron-right wallet-switch-icon"
        :class="{ rotate: activeWallet === 'bonus' }"
      ></i>
    </div>
    <div class="wallet-card wallet-bonus flex-between">
      <div class="wallet-info">
        <div class="wallet-label">{{ $t('home.referBonusLabel') }}</div>
        <div>
          <span class="wallet-amount">
            {{ $options.filters.numberFormat(inviteAmount) }}
          </span>
          {{ $t('modals.transfer.bahtTxt') }}
        </div>
      </div>
      <div class="wallet-action bonus-recieve" @click="addInviteBonusToWallet">
        {{ $t('home.receiveBtn') }}
      </div>
    </div>
    <modal-spin
      v-if="modalSpinActive"
      :is-active="modalSpinActive"
      @closeModal="
        () => {
          modalSpin()
          this.getUserWallet(true)
        }
      "
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import i18n from '@/language'
import VueBreakpointMixin from 'vue-breakpoint-mixin'

import apiWallet from '@/api/wallet'
import apiInvite from '@/api/invite'
import apiSpin from '@/api/spin'

import ModalSpin from '@/views/user/components/modals/spin'

export default {
  name: 'Wallet',
  mixins: [VueBreakpointMixin],
  props: {
    page: String
  },
  components: {
    ModalSpin
  },
  data() {
    return {
      activeWallet: 'cash',
      modalSpinActive: false,
      isSpinActive: false
    }
  },
  computed: {
    ...mapState({
      timesync: store => store.userInfo.timesync,
      total: store => store.userInfo.total,
      inviteAmount: store => store.userInfo.inviteAmount,
      inviteSuccess: store => store.userInfo.inviteSuccess,
      inviteFail: store => store.userInfo.inviteFail,
      profile: store => store.userInfo.profile
    })
  },
  created() {
    this.refreshAllSlot()
    this.checkSpinActive()
  },
  methods: {
    ...mapActions('userInfo', ['getUserWallet']),
    async refreshAllSlot() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          await apiWallet.refreshAllSlot()
        } catch (error) {
          console.log(error)
        } finally {
          await this.getUserWallet(true)
          loading.hide()
        }
      }, 200)
    },
    async addInviteBonusToWallet() {
      this.$buefy.dialog.confirm({
        title: i18n.t('home.receivedInviteBonusMsg'),
        message: `*** ${i18n.t('home.condition1Msg')} ***${
          this.inviteSuccess > 0
            ? `<br><br>${i18n.t('home.condition2Msg')} <b>${
                this.inviteSuccess
              }%</b> ${i18n.t('home.condition3Msg')}<br><br>` +
              `*** ${i18n.t('home.condition4Msg')} <b>${this.inviteFail}%</b>
            ${i18n.t('home.condition5Msg')}
            <span class="has-text-danger"><b>${i18n.t(
              'home.condition6Msg'
            )}</b></span> ***</div><br>`
            : ''
        }`,
        confirmText: i18n.t('home.confirmMsg'),
        cancelText: i18n.t('home.cancelMsg'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          try {
            await apiInvite.receviedInviteBonus()
            this.$buefy.toast.open({
              message: i18n.t('home.successMsg'),
              type: 'is-success'
            })

            this.getUserWallet()
          } catch (error) {
            this.$buefy.toast.open({
              message: error,
              type: 'is-danger'
            })
          }
        }
      })
    },
    switchWallet() {
      let direction
      if (this.activeWallet === 'cash') {
        this.activeWallet = 'bonus'
        direction = 1
      } else {
        this.activeWallet = 'cash'
        direction = -1
      }

      this.$refs.wallet.scrollTo({
        top: 0,
        left: direction * this.$refs.wallet.scrollWidth,
        behavior: 'smooth'
      })
    },
    modalSlot(slot) {
      this.modalSlotActive = !this.modalSlotActive
      this.disabledBodyScroll(this.modalSlotActive)

      if (slot) this.selectedSlot = slot
      else this.selectedSlot = {}
    },
    modalAgreement() {
      this.modalAgreementActive = !this.modalAgreementActive
      this.disabledBodyScroll(this.modalAgreementActive)
    },
    disabledBodyScroll(isModalShow) {
      if (isModalShow) document.documentElement.style.overflow = 'hidden'
      else document.documentElement.style.overflow = 'auto'
    },
    modalSpin() {
      this.modalSpinActive = !this.modalSpinActive
    },
    async checkSpinActive() {
      const result = await apiSpin.isActive()
      this.isSpinActive = result.isActive
    }
  }
}
</script>

<style scoped lang="scss">
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.wallet {
  text-align: center;
  overflow: hidden;
}

.wallet-card {
  margin: 10px 0;
  border-radius: 5px;
  height: 120px;
  width: 50%;
  min-width: 300px;
}

.wallet-info {
  margin-top: 30px;
  width: 75%;
  height: 100%;

  .wallet-label {
    font-size: large;
    align-self: flex-start;
  }

  .wallet-amount {
    font-size: 1.9rem;
    font-weight: 700;
    line-height: 2.8rem;
  }

  .wallet-update {
    margin-top: 10px;
    font-size: xx-small;
    color: $light-primary;
  }
}

.wallet-action {
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.wallet-cash {
  background-image: linear-gradient(
    to bottom,
    lighten($color: $primary, $amount: 10) 0%,
    darken($color: $primary, $amount: 5) 100%
  );
}

.wallet-bonus {
  background-image: linear-gradient(
    to bottom,
    lighten($color: $primary, $amount: 10) 0%,
    darken($color: $primary, $amount: 5) 100%
  );
}

.wallet-switch {
  font-size: 1.8rem;
  height: 120px;
  min-width: calc(100% - 310px);
  background-color: lighten($color: $primary, $amount: 30);
}

.wallet-switch-icon {
  transition: transform 0.5s ease-in-out;
}

.wallet-switch-icon.rotate {
  transform: scaleX(-1);
}

.cash-refresh {
  height: 100%;
  width: 25%;
  background-color: lighten($color: $primary, $amount: 15);
  box-shadow: 5px 0 10px -5px #27272776;
  font-size: 1.8rem;
}

.bonus-recieve {
  height: 100%;
  width: 25%;
  background-color: lighten($color: $primary, $amount: 15);
  box-shadow: -5px 0 10px -5px #27272776;
  font-size: 2.2rem;
  font-weight: 500;
}

.button {
  &.small {
    padding: 0px 5px !important;
    border-radius: 10px;
    height: fit-content;
  }
}

.flex {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
</style>
